import PropTypes from "prop-types";
import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import { View, ScrollView, ActivityIndicator, FlatList } from "react-native";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import { styleSheet } from "app/utils/styleSheet";
// import Autocomplete from "react-native-autocomplete-input";
import { Entypo, AntDesign } from "@expo/vector-icons";
import TextInput from "app/components/TextInput";

import * as RootNavigation from "app/utils/RootNavigation.js";
import store from "app/redux/store";
// used at render time only, so the Autocomplete↔MomentBullet cycle is safe
// (same pattern as Tag and RichText)
import MomentBullet from "app/components/chapter/MomentBullet";
import ValueListItem from "app/components/ValueListItem";
import valueActions from "app/utils/valueActions";
import chapterActions from "app/utils/chapterActions";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import Icon from "app/components/Icon";

import { StyleContext } from "app/contexts/Style";

export default class AutocompleteComp extends React.Component {
  static contextType = StyleContext;
  componentDidMount() {
    // if (this.props.autoHeight) this.applyAutoHeight();
    if (ENV.WEB) {
      document.addEventListener("keyup", this.handleKeyUp);
      document.addEventListener("keydown", this.handleKeyDown);
    }

    if (this.props.autoFocus && ENV.WEB) {
      if (this.inputRef) {
        this.inputRef.focus();
      } else {
        console.log("no ref");
      }
    }
    if (!!this.props.query?.length) {
      this.fetch();
    }

    this.props.setRef && this.props.setRef(this);
  }

  componentWillUnmount() {
    if (ENV.WEB) {
      document.removeEventListener("keyup", this.handleKeyUp);
      document.removeEventListener("keydown", this.handleKeyDown);
    }
    if (!!this.patientFetchTimeout) clearTimeout(this.patientFetchTimeout);
    this.unmounted = true;
  }

  componentDidUpdate(prevProps) {
    // When suggestions are closed, clear cached values so they don't reappear next time
    if (prevProps.noSuggestions === false && this.props.noSuggestions === true) {
      this.setState({
        values: [],
        showMore: 0,
        startAtSuggestion: 0,
        expandedSuggestionId: null,
      });
      this.props.setFirstSuggestion && this.props.setFirstSuggestion(null);
    }
    if (
      prevProps.query != this.props.query ||
      prevProps.noSuggestions != this.props.noSuggestions
    ) {
      this.handleChangeText(this.props.query, true);
      // On mobile, controlled value="" doesn't always clear the native TextInput visually.
      // Imperatively clear it when query resets to empty.
      if (!ENV.WEB && !this.props.query && prevProps.query) {
        this.inputRef?.clear && this.inputRef.clear();
      }
    }
    // if (prevProps.autoHeight != this.props.autoHeight) {
    //   if (this.props.autoHeight) {
    //     this.applyAutoHeight();
    //     this.inputRef.focus();
    //   }
    // }
  }

  handleKeyUp = (e) => {
    if (this.state.focused) {
      if (e.key == "Meta") {
        this.setState({ meta: false });
        this.props.onSetMeta && this.props.onSetMeta(false);
      } else if (e.key == "Shift") {
        this.setState({ shift: false });
        this.props.onSetShift && this.props.onSetShift(false);
      }
    }
    // if (this.props.autoHeight) this.applyAutoHeight();
  };

  handleKeyDown = (e) => {
    if (this.state.focused) {
      if (e.key == "Meta") {
        this.setState({ meta: true });
        this.props.onSetMeta && this.props.onSetMeta(true);
      } else if (e.key == "Shift") {
        this.setState({ shift: true });
        this.props.onSetShift && this.props.onSetShift(true);
      }
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      values: [],
      loading: false,
      showMore: 0,
      startAtSuggestion: 0,
      // focused: props.autoFocus,
      focused: false,
      shift: false,
      meta: false,
      suggestions: [],
      height: null,
      enterLoading: false,
      expandedSuggestionId: null,
    };
  }

  // expand a suggestion row into its full MomentBullet — from there parents
  // and children can be browsed, and Enter on any bullet inherits the
  // composer's select action instead of progressing the value
  toggleExpandSuggestion = (value) => {
    this.setState({
      expandedSuggestionId:
        this.state.expandedSuggestionId == value.id ? null : value.id,
    });
  };

  // collapse the expanded suggestion and hand focus back to the root input
  collapseExpandedSuggestion = () => {
    if (!this.state.expandedSuggestionId) return;
    this.setState({ expandedSuggestionId: null });
    setTimeout(() => this.inputRef?.focus && this.inputRef.focus(), 0);
  };

  // Tab (with suggestions open): expand the top suggestion's bullet and move
  // the cursor into it. Returns true when handled.
  expandFirstSuggestion = () => {
    if (this.props.noSuggestions) return false;
    let firstItem = this.getSuggestions()[0];
    if (!firstItem?.id || !!firstItem.type) return false; // plain values only
    if (this.state.expandedSuggestionId != firstItem.id) {
      this.setState({ expandedSuggestionId: firstItem.id });
    }
    setTimeout(() => {
      this.expandedBulletInputRef?.focus && this.expandedBulletInputRef.focus();
    }, 50);
    return true;
  };

  renderSuggestionBullet = (value) => {
    if (this.state.expandedSuggestionId != value.id) return null;
    let full = store.getState().values.find((v) => v.id == value.id) || value;
    return (
      <View
        style={{
          marginLeft: this.context.sizes.base,
          paddingLeft: this.context.sizes.small,
          borderLeftWidth: 1,
          borderColor: this.context.colors.trim,
          backgroundColor: this.props.backgroundColor,
        }}
      >
        <MomentBullet
          moment={{ value: full }}
          inputRef={(r) => (this.expandedBulletInputRef = r)}
          onSelectValue={(v) =>
            this.props.onSelectItem && this.props.onSelectItem(v)
          }
          onEscape={this.collapseExpandedSuggestion}
          onBrowseEscape={this.collapseExpandedSuggestion}
        />
      </View>
    );
  };

  fetch = async (reset = true) => {
    if (this.unmounted) return;
    if (!!this.patientFetchTimeout) clearTimeout(this.patientFetchTimeout);
    this.firstFetchMade = true;
    let { query, excludeIds } = this.props;
    let { values, showMore } = this.state;
    if (reset) {
      await this.setState({
        showMore: 0,
        startAtSuggestion: 0,
        expandedSuggestionId: null,
      });
      values = [];
    }
    await this.setState({ loading: true });
    this.props.onLoadingChange && this.props.onLoadingChange(true);
    this.lastFetchAt = new Date().getTime();
    if (query.includes("#")) {
      query = query.split("#")[1];
      if (!query?.length) {
        // nothing after the "#" yet — wait for real input instead of
        // asking the server for everything
        await this.setState({ loading: false });
        this.props.onLoadingChange && this.props.onLoadingChange(false);
        return;
      }
    }
    this.lastFetchedQuery = query;
    const fetchedQuery = query; // capture so we can detect stale responses
    let newValues = await valueActions.autocompleteValues(query, showMore);
    // If a newer fetch has since been started, discard this stale response
    if (this.unmounted || this.lastFetchedQuery !== fetchedQuery) return;
    values = newValues;

    values = values.map((v) => {
      if (!!v.value_id || !!v.chapter_id) {
        return { ...v, type: "moment" };
      } else return v;
    });

    if (this.props.suggestChapters) {
      let chapters = await chapterActions.autocompleteChapters(query);
      // console.log("chapter suggestions", chapters);
      if (!!chapters?.length) {
        chapters = chapters.map((c) => ({
          ...c,
          title: c.start_at ? `${c.title} – ${c.start_at}` : c.title,
          icon: "open-book",
          type: "chapter",
        }));
      } else {
        chapters = [];
      }
      values = [...values, ...chapters];
    }

    // let suggestions = newValues;
    // values = [...values, ...newValues];
    // values = textHelpers.uniq(values, "id");
    // let suggestions = textHelpers.suggestions(query, values, excludeIds);
    // if (query.length > 3 && !suggestions.length && showMore < 2) {
    if (this.unmounted) return;
    if (query?.length >= 3 && !values?.length && showMore < 2) {
      this.fetchMore();
      return;
    }
    await this.setState({ loading: false, values });
    this.props.onLoadingChange && this.props.onLoadingChange(false);
    setTimeout(() => {
      console.log("setting sugg", this.getSuggestions());
      if (!this.props.noSuggestions) {
        this.props.setFirstSuggestion &&
          this.props.setFirstSuggestion(this.getSuggestions()[0]);
      }
    }, 0);
  };

  fetchMore = async () => {
    if (this.unmounted) return;
    // let { showMore } = this.state;
    console.log("initial showMore", this.state.showMore);
    let showMore = this.state.showMore + 1;
    await this.setState({ showMore });
    // await new Promise(r => setTimeout(r, 0)
    console.log("fetch more", showMore, this.state.showMore);
    this.fetch(false);
  };

  handleKeyPress = async (event) => {
    this.props.onKeyPress && this.props.onKeyPress(event);

    let key = event.nativeEvent.key;

    if (key == "Escape") {
      // if (event.metaKey || event.shiftKey) {
      //   if (this.props.onCancel) this.props.onCancel();
      // } else {
      // if (this.props.clearSuggestionsOnEscape)
      this.setState({ values: [], showMore: 0 });
      if (this.props.onCancel) {
        this.props.onCancel();
      } else {
        this.props.onChangeText && this.props.onChangeText("");
      }
      if (!this.state.query?.length) {
        // console.log("blur");
        this.inputRef?.blur();
      }
      // }
      return;
    }
    if (key == "Enter") {
      let firstItem = null;
      if (this.props.submitFirstOnPressEnter && !this.props.noSuggestions) {
        firstItem = this.getSuggestions()[0];
        // console.log("first item!", this.getSuggestions(), firstItem);
      }
      let actionTaken = false;
      if (event.metaKey && !!this.props.onMetaEnter) {
        event.preventDefault();
        this.props.onMetaEnter(firstItem);
        actionTaken = true;
      } else if (event.shiftKey && !!this.props.onShiftEnter) {
        event.preventDefault();
        this.props.onShiftEnter(firstItem);
        actionTaken = true;
      } else if (!!this.props.onEnter) {
        if (!this.props.captureEnterOnlyWithItem || !!firstItem) {
          event.preventDefault();
          this.props.onEnter(firstItem, event);
          actionTaken = true;
        }
      } else if (!!this.props.onSelectItem && !!firstItem) {
        event.preventDefault();
        this.props.onSelectItem(firstItem, event);
        actionTaken = true;
      }
      if (actionTaken) {
        this.setState({ enterLoading: true });
      }
      return;
    }
    if (key == "Tab") {
      // with suggestions open, Tab dives into the top suggestion's bullet
      if (!event.shiftKey && this.expandFirstSuggestion()) {
        event.preventDefault();
        return;
      }
      if (!!this.props.onPressTab) {
        this.props.onPressTab();
        event.preventDefault();
      }
      if (!!this.props.submitFirstOnPressTab) {
        event.preventDefault();
        let firstItem = this.getSuggestions()[0];
        if (!!firstItem) {
          this.props.onSelectItem && this.props.onSelectItem(firstItem, event);
        } else {
          this.fetchMore();
        }
      }
      return;
    }
    if (key == "ArrowUp") {
      if (event.altKey && !!this.props.onAltUp) {
        this.props.onAltUp();
        return;
      } else if (event.metaKey && !!this.props.onMetaUp) {
        this.props.onMetaUp();
        return;
      } else if (this.props.onNatUp) {
        this.props.onNatUp();
        return;
      }
    }
    if (key == "ArrowDown") {
      if (event.altKey && !!this.props.onAltDown) {
        this.props.onAltDown();
        return;
      } else if (event.metaKey && this.expandFirstSuggestion()) {
        // cmd+down dives into the top suggestion's bullet, like Tab
        event.preventDefault();
        return;
      } else if (event.metaKey && !!this.props.onMetaDown) {
        this.props.onMetaDown();
      } else {
        // check natDown after suggestions
      }
    }
    if (key == "ArrowLeft") {
      if (!!this.props.onNatLeft) {
        this.props.onNatLeft();
        return;
      } else if (event.altKey && !!this.props.onAltLeft) {
        this.props.onAltLeft();
        return;
      }
    }
    if (key == "ArrowRight") {
      if (!!this.props.onNatRight) {
        this.props.onNatRight();
        return;
      } else if (event.altKey && !!this.props.onAltRight) {
        this.props.onAltRight();
        return;
      }
    }

    let { query, excludeIds } = this.props;
    let { values } = this.state;
    // console.log("setting suggestions for:", query);

    // check this one after suggestions
    let startAtSuggestion = this.state.startAtSuggestion;
    if (key == "ArrowDown") {
      // if (!!suggestions.length && !this.props.renderItem) {
      if (!this.props.renderItem && !!this.firstFetchMade) {
        startAtSuggestion = startAtSuggestion + 1;

        let suggestions = this.getSuggestions(true);
        if (suggestions?.length <= startAtSuggestion) {
          startAtSuggestion = 0;
          this.fetchMore();
        }
        event.preventDefault();
        // console.log("down", suggestions, startAtSuggestion);
        // startAtSuggestion = Math.min(suggestions.length - 1, startAtSuggestion);
        // console.log(startAtSuggestion);
      } else if (this.props.onNatDown) {
        this.props.onNatDown();
        return;
      }
    } else {
      // Only reset index for non-modifier keys (don't reset when pressing cmd, shift, ctrl, alt, etc.)
      // NB: ArrowUp intentionally NOT in this list — pressing up resets the
      // suggestion list back to the top
      const modifierKeys = ['Meta', 'Shift', 'Control', 'Alt', 'CapsLock', 'Tab', 'Escape', 'ArrowLeft', 'ArrowRight', 'Enter'];
      if (!modifierKeys.includes(key)) {
        startAtSuggestion = 0;
      }
    }

    await this.setState({ startAtSuggestion });

    // console.log("selected", suggestions[startAtSuggestion]);
    this.props.setFirstSuggestion &&
      this.props.setFirstSuggestion(this.getSuggestions()[0]);
  };

  nextSuggestion = async () => {
    // this may be called from the parent comp (in MomentBullet)
    let startAtSuggestion = this.state.startAtSuggestion + 1;
    await this.setState({ startAtSuggestion });
    this.props.setFirstSuggestion &&
      this.props.setFirstSuggestion(this.getSuggestions()[0]);
  };

  handleChangeText = (text, forceFetch = false) => {
    if (!text?.length) {
      // No text — clear everything regardless of suggestion visibility
      this.firstFetchMade = false;
      if (this.patientFetchTimeout) clearTimeout(this.patientFetchTimeout);
      this.lastFetchedQuery = null;
      // Also stop any in-flight fetch's spinner: fetch() early-returns as
      // stale after this, so it would never reset loading itself
      this.setState({
        showMore: 0,
        values: [],
        startAtSuggestion: 0,
        loading: false,
        enterLoading: false,
      });
      this.props.onLoadingChange && this.props.onLoadingChange(false);
      this.props.setFirstSuggestion && this.props.setFirstSuggestion(null);
    } else if (!this.props.noSuggestions) {
      // only the fragment after "#" is actually searched — gate on it, not
      // the full text, so a trailing "#p" doesn't fire 0-2 char queries
      // that force the server to scan every value and moment
      let hasHash = text.includes("#");
      let effective = hasHash ? text.split("#")[1] : text;
      let longEnough = hasHash
        ? effective?.length >= 2
        : text?.length > 3;
      if (longEnough || forceFetch) {
        this.props.setFirstSuggestion &&
          this.props.setFirstSuggestion(this.getSuggestions()[0]);
        this.patientFetch(forceFetch);
      }
    }
  };

  patientFetch = async (skipDelay = false) => {
    let delay = 1000 * 1;
    if (skipDelay) delay = 0;
    if (!this.patientFetchTimeout || !this.firstFetchMade) delay = 0;

    if (!!this.patientFetchTimeout) clearTimeout(this.patientFetchTimeout);

    this.patientFetchTimeout = setTimeout(() => {
      if (this.unmounted) return;
      console.log("pateintence paid off, fetching", delay);
      this.fetch();
    }, delay);

    // await new Promise(r => setTimeout(r, delay))
    // let now = new Date().getTime()
    // if(now - this.lastFetchAt < delay)
  };

  applyAutoHeight = () => {
    // console.log("scrollheight: ", this.ref, this.ref?.textInput?.scrollHeight);
    if (!!this.ref?.textInput?.scrollHeight) {
      this.setState({ height: this.ref.scrollHeight });
    }
    // this.ref?.measure((x, y, width, height, pageX, pageY) => {
    //   console.log(`first-- w:${width}, h:${height}, px:${pageX}, py:${pageY}`);
    // });
  };

  getSuggestions = (ignoreStartAt = false) => {
    let { query, excludeIds } = this.props;
    if (query.includes("#")) query = query.split("#")[1];
    let { startAtSuggestion, values } = this.state;
    let suggestions = textHelpers.suggestions(query, values, excludeIds);
    // console.log(suggestions, excludeIds);
    startAtSuggestion = Math.min(startAtSuggestion, suggestions.length - 1);
    if (!ignoreStartAt) {
      suggestions.splice(0, startAtSuggestion);
    }
    return suggestions;
  };

  render() {
    let {
      query,
      suggestionsOnly,
      simpleListView,
      excludeIds,
      autoHeight,
      onChangeHeight,
    } = this.props;
    let { values, showMore, loading, startAtSuggestion, height, enterLoading } =
      this.state;

    let { inputRef, ref, ...safeProps } = this.props;

    let suggestions = this.getSuggestions();

    return (
      <View
        style={[
          !suggestionsOnly && this.context.styleSheet.input,
          this.props.extraStyle,
        ]}
      >
        <View>
          <TextInput
            keyboardAccType={"composer"}
            autoFocus={ENV.WEB ? this.props.autoFocus : false}
            placeholderTextColor={this.context.colors.trim}
            value={query}
            {...this.props}
            inputRef={(r) => {
              inputRef && inputRef(r);
              this.inputRef = r;
            }}
            autoHeight={autoHeight}
            onChangeHeight={onChangeHeight}
            onFocus={() => {
              this.setState({ focused: true });
              this.props.onFocus && this.props.onFocus();
            }}
            onBlur={() => {
              this.setState({ focused: false });
              this.props.onBlur && this.props.onBlur();
            }}
            onKeyPress={(e) => {
              this.handleKeyPress(e);
            }}
            // onChangeText={(e) => {
            //   console.warn(e);
            //   if (!ENV.WEB) {
            //     // this.handleChangeText(e)
            //   }
            // }}
            containerStyle={{ zIndex: 1 }}
            style={[
              styleSheet.input,
              { flex: 1, height: "auto", minHeight: undefined },
              this.props.inputStyle,
              { borderWidth: 0 },
              suggestionsOnly && { height: 0, width: 0 },
              this.props.inputContainerStyle,
              suggestionsOnly && { display: "none" },
              { minWidth: 80 },
              { color: this.context.colors.foreground },
            ]}
          />
        </View>

        <View>
          <FlatList
            style={[
              {
                zIndex: 1,
                backgroundColor: this.context.colors.empty,
              },
              // !!suggestions?.length && { padding: this.context.sizes.base },
            ]}
            data={this.props.noSuggestions ? [] : suggestions}
            keyboardShouldPersistTaps={"always"}
            renderItem={({ item: value, index: i }) => {
              if (!!this.props.renderItem) {
                return this.props.renderItem({ item: value, index: i });
              }
              // if (!!startAtSuggestion && i < startAtSuggestion) return null;
              if (simpleListView) {
                let expandable = !value.type; // plain values only
                return (
                  <View key={`suggestion-${i}`}>
                    <View
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <TouchableOpacity
                        style={{ flex: 1 }}
                        onMouseDown={(e) => {
                          ENV.WEB &&
                            this.props.onSelectItem &&
                            this.props.onSelectItem(value, e);
                        }}
                        onPress={
                          ENV.WEB
                            ? null
                            : (e) => {
                                this.props.onSelectItem &&
                                  this.props.onSelectItem(value, e);
                              }
                        }
                      >
                    <View
                      style={[
                        {
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        },
                        i == 0 &&
                          (!!this.props.submitFirstOnPressEnter ||
                            !!this.props.submitFirstOnPressTab) && {
                            backgroundColor: this.context.colors.fill,
                          },
                        value.type == "chapter" && {
                          opacity: 0.5,
                        },
                      ]}
                    >
                      <Text
                        numberOfLines={1}
                        strike={!!value.completed_at}
                        style={[
                          {
                            flex: 1,
                            maxWidth: 400,
                            paddingHorizontal: this.context.sizes.base,
                            paddingVertical: ENV.WEB
                              ? this.context.sizes.tiny
                              : this.context.sizes.base,
                            backgroundColor: this.props.backgroundColor,
                            borderBottomWidth: 1,
                            borderColor: this.context.colors.trim,
                          },
                        ]}
                      >
                        <Icon
                          name={valueHelpers.getIcon(value)}
                          color={valueHelpers.colorAsHex(
                            value?.color || value.inherited_color,
                            this.context.colorScheme,
                          )}
                          size={this.context.sizes.default}
                        />{" "}
                        {valueHelpers.filterRichText(
                          value.title || value.text,
                          value,
                          undefined,
                          values,
                        )}
                      </Text>
                      {i == 0 && enterLoading ? (
                        <ActivityIndicator
                          size={"small"}
                          color={this.context.colors.foreground}
                        />
                      ) : (
                        (!!this.props.submitFirstOnPressEnter ||
                          !!this.props.submitFirstOnPressTab) && (
                          <AntDesign
                            name="enter"
                            color={this.context.colors.foreground}
                            size={this.context.sizes.default}
                            style={{ marginRight: this.context.sizes.base }}
                          />
                        )
                      )}
                    </View>
                      </TouchableOpacity>
                      {expandable && (
                        <Text
                          style={{
                            color: this.context.colors.trim,
                            paddingHorizontal: this.context.sizes.small,
                            fontSize: this.context.sizes.default,
                          }}
                          onMouseDown={(e) => {
                            if (!ENV.WEB) return;
                            e.preventDefault && e.preventDefault();
                            e.stopPropagation && e.stopPropagation();
                            this.toggleExpandSuggestion(value);
                          }}
                          onPress={
                            ENV.WEB
                              ? null
                              : () => this.toggleExpandSuggestion(value)
                          }
                        >
                          {this.state.expandedSuggestionId == value.id
                            ? "▾"
                            : "▸"}
                        </Text>
                      )}
                    </View>
                    {expandable && this.renderSuggestionBullet(value)}
                  </View>
                );
              } else {
                return (
                  <ValueListItem
                    key={i}
                    value={value}
                    hideButtons
                    customIcon={(style) => (
                      <Entypo
                        name={"chevron-right"}
                        color={this.context.colors.lightForeground}
                        style={[style, { opacity: 0.5 }]}
                      />
                    )}
                    onSubmit={() => {
                      if (this.props.onSelectItem)
                        this.props.onSelectItem(value);
                      else RootNavigation.push("Value", { id: value.id });
                    }}
                  />
                );
              }
            }}
          />
        </View>

        {loading && (
          <ActivityIndicator
            size={"small"}
            color={this.context.colors.foreground}
            style={{ opacity: 0.5, position: "absolute" }}
          />
        )}
        {!loading &&
          showMore < 2 &&
          !!query?.length &&
          !this.props.noGetMore &&
          !this.props.noSuggestions && (
            <Text
              style={{
                // paddingHorizontal: this.context.sizes.base,
                padding: this.context.sizes.base,
                backgroundColor: this.context.colors.trim,
              }}
              onPress={this.fetchMore}
            >
              Get More
            </Text>
          )}
        {this.state.focused && !!this.props.extraItem && (
          <Text
            style={{
              padding: this.context.sizes.base,
              // backgroundColor: this.context.colors.trim,
            }}
            onPress={this.props.onPressExtraItem}
            onMouseDown={this.props.onPressExtraItem}
          >
            {this.props.extraItem}
          </Text>
        )}
      </View>
    );
  }
}
